var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"white"},[_c('v-col',[_c('div',{staticClass:"text-center"},[_vm._v("Silahkan tunggu sebentar")]),_c('v-row',{attrs:{"justify":"center"}},[_c('v-col',{staticStyle:{"padding":"2rem"},attrs:{"cols":"12","md":"8"}},[_c('v-progress-linear',{attrs:{"indeterminate":""}})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }